import React, { useState, Component, useRef, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Redirect } from "react-router-dom";
import { Divider, Icon, Tooltip } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Badge from "@material-ui/core/Badge";
import ProductCard from "../../Components/Product-Card/ProductCard";
import StoreProducts from "../../Components/Store-Products/Store-Products";
import Rating from "@material-ui/lab/Rating";
import LinearProgress from "@material-ui/core/LinearProgress";
import Snackbar from "@material-ui/core/Snackbar";
import { useHistory, useLocation, Link } from "react-router-dom";
import MuiAlert from "@material-ui/lab/Alert";

//importing icons
import AirportShuttleOutlinedIcon from "@material-ui/icons/AirportShuttleOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import StoreIcon from "@material-ui/icons/Store";
import ForumIcon from "@material-ui/icons/Forum";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import StarHalfIcon from "@material-ui/icons/StarHalf";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

//importing files
import { useUserContext } from "../../context/UserContext";
import storeImg from "../../assets/images/Store/store9.png";
import storeImg2 from "../../assets/images/Store/store8.png";
import productImg from "../../assets/images/Product Images/wirelesHeadPhone.jpg";
import productImg2 from "../../assets/images/Product Images/bluetooth-headphone.jpg";
import productImage2 from "../../assets/images/Product Images/hummingbird-printed-t-shirt (1).jpg";
import noImage from "../../assets/images/Product Images/noImage.png";
import api from "../../Axios/api";

// MUI Components
import { Grid, Typography, Button } from "@material-ui/core";
import { Reply } from "@material-ui/icons";

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className={classes.TabBox}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Store() {
  const classes = useStyles();

  let token = null;
  let userId = "";
  const { store } = useUserContext();
  if (store.data !== null) {
    token = store.data.token;
    if (store.data.data) userId = store.data.data._id;
  }
  const history = useHistory();
  const [value, setValue] = React.useState(0);
  const search = useLocation().search;
  const selectedStoreId = new URLSearchParams(search).get("storeId");
  const [storeDetails, setStoreDetails] = useState(null);
  const [storeReviews, setStoreReviews] = useState([]);
  const [positiveSellerRating, setPositiveSellerRating] = useState(0);
  const [countOfStoreSubscribers, setCountOfStoreSubscribers] = useState(0);
  const [avgRatingOfStore, setAverageRatingOfStore] = useState(0);
  const [fourRatingCount, setFourRatingCount] = useState(0);
  const [oneRatingCount, setOneRatingCount] = useState(0);
  const [twoRatingCount, setTwoRatingCount] = useState(0);
  const [threeRatingCount, setThreeRatingCount] = useState(0);
  const [fiveRatingCount, setFiveRatingCount] = useState(0);
  const [data, setData] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSubscribeToStore = () => {
    if (!token) {
      window.location.href = `/buyer/login`;
    }
    api
      .patch(
        !isSubscribed ? `/buyer/store/subscribe` : `/buyer/store/Unsubscribe`,
        { storeId: storeDetails ? storeDetails._id : selectedStoreId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (isSubscribed) {
          console.log("Unsubscribed", res.data);
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Un-Subscribed to Store.",
            open: true,
          });
          setCountOfStoreSubscribers(countOfStoreSubscribers - 1);
          setIsSubscribed(false);
        } else {
          console.log("subscribed", res.data);
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Successfully Subscribed to Store.",
            open: true,
          });
          setCountOfStoreSubscribers(countOfStoreSubscribers + 1);
          setIsSubscribed(true);
        }
      })
      .catch((error) =>
        error.response
          ? setSnackBar({
              ...snackBarstate,
              message: JSON.stringify(
                error.response
                  ? error.response.data
                    ? error.response.data.error
                      ? error.response.data.error.message +
                        "  Login from your account!"
                      : "Sorry! Cannot subscribe to store!"
                    : "Sorry! Cannot subscribe to store!"
                  : "Sorry! Cannot subscribe to store!"
              ).replace(/"/g, ""),
              type: "error",
              open: true,
            })
          : null
      );
  };

  const retrivingAllSubscribers = async () => {
    await api
      .get(`/buyer/isSubscribed/store/${selectedStoreId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const subscribersCount = res.data.data.subscribers;
        if (subscribersCount > 0) {
          setIsSubscribed(true);
        }
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    //for checking if subscribed to store
    retrivingAllSubscribers();
    api
      .get(`/buyer/data/store/${selectedStoreId}`, {}, { Headers: {} })
      .then((res) => {
        const data = res.data.data;
        setData(data);
        // console.log(data);
        setStoreDetails(data.storeDetails);
        setPositiveSellerRating(data.positiveSellerRatingPercentage);
        setCountOfStoreSubscribers(data.countOfStoreSubscribers);
        // console.log("top Reviewd", data.TopReviewedProducts);
      })
      .catch((error) => console.log("error in getting data of store", error));

    api
      .get(`/buyer/reviews/store/${selectedStoreId}`, {}, { Headers: {} })
      .then((res) => {
        console.log(res.data.data);
        setStoreReviews(res.data.data.reviews);
        setAverageRatingOfStore(res.data.data.avgRatingOfStore);
        getCountOfEveryRating(res.data.data.reviews);
      })
      .catch((error) => console.log("error in getting data of store", error));
  }, [selectedStoreId]);

  const getCountOfEveryRating = (reviews) => {
    for (let index = 0; index < reviews.length; index++) {
      const element = reviews[index];
      const rating = Math.floor(element.rating);
      // console.log(rating)
      if (rating === 1) {
        setOneRatingCount(oneRatingCount + 1);
      }
      if (rating === 2) {
        setTwoRatingCount(twoRatingCount + 1);
      }
      if (rating === 3) {
        setThreeRatingCount(threeRatingCount + 1);
      }
      if (rating === 4) {
        setFourRatingCount(fourRatingCount + 1);
      }
      if (rating === 5) {
        setFiveRatingCount(fiveRatingCount + 1);
      }
    }
  };

  const getTopSellingProducts = () => {
    return data
      ? data.TopSellingProducts.length >= 2
        ? data.TopSellingProducts
        : data.TopSellingProducts.length === 1
        ? [
            data.TopSellingProducts[0],
            data.TopReviewedProducts.length >= 4
              ? data.TopReviewedProducts[3]
              : data.TopReviewedProducts[0],
          ]
        : data.TopReviewedProducts.length >= 5
        ? [data.TopReviewedProducts[3], data.TopReviewedProducts[4]]
        : data.ForYouProducts.length === 3
        ? [data.ForYouProducts[0], data.ForYouProducts[1]]
        : null
      : null;
  };

  const openProductPage = (productId) => {
    return history.push(`/product?productId=${productId}`);
  };

  return (
    <div>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 16 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} color="inherit" to="/">
            Home
          </Link>
          <Typography color="textPrimary">Store</Typography>
          <Typography color="textPrimary">
            {storeDetails ? storeDetails.name : ""}
          </Typography>
        </Breadcrumbs>

        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>

        <div className={classes.mainStoreContainer}>
          <div className={classes.storeBanner}>
            <div className={classes.storeTitle}>
              {/* Title */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <StoreIcon fontSize="large" style={{ marginRight: 10 }} />
                <Typography
                  variant="h4"
                  noWrap
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {storeDetails ? storeDetails.name : ""}
                </Typography>
              </div>
              {/* Followers and ratings */}
              <div style={{ paddingLeft: 3, paddingTop: 5 }}>
                <Typography style={{ color: "#666" }} variant="p">
                  {countOfStoreSubscribers} follower(s)
                </Typography>
                <Typography style={{ color: "#666" }} variant="h6">
                  {positiveSellerRating > 0
                    ? `${positiveSellerRating}% positive seller rating`
                    : ""}
                </Typography>
              </div>
              {/* Chat and subscribe btn */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 5,
                }}
              >
                <Button
                  variant="outlined"
                  className={classes.chatBtn}
                  color="primary"
                  style={{
                    display: "flex",
                    color: "primary",
                    fontWeight: "bold",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    padding: 5,
                    marginRight: 3,
                  }}
                >
                  <ForumIcon style={{ padding: 2, marginRight: 2 }} />
                  <Link
                    style={{ textDecoration: "none", color: "black" }}
                    to={
                      token
                        ? `/buyer/messages?sellerId=${
                            storeDetails ? storeDetails.sellerId : null
                          }`
                        : `/buyer/login`
                    }
                  >
                    Chat Now{" "}
                  </Link>
                </Button>

                <Button
                  className={classes.chatBtn}
                  variant="outlined"
                  color="primary"
                  style={{
                    display: "flex",
                    fontWeight: "bold",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    padding: 5,
                    backgroundColor: isSubscribed ? "#EF233C" : "transparent",
                    color: isSubscribed ? "white" : "black",
                  }}
                  onClick={handleSubscribeToStore}
                >
                  <CardMembershipIcon
                    // color="primary"
                    style={{
                      padding: 2,
                      marginRight: 2,
                      color: isSubscribed ? "white" : "#EF233C",
                    }}
                  />
                  {isSubscribed ? `Un-Subscribe` : `Subscribe`}{" "}
                </Button>
              </div>
            </div>

            <div
              className={classes.storeImage}
              style={{ backgroundImage: `url('${storeImg2}')` }}
            ></div>
            <div
              className={classes.storeImage}
              style={{ backgroundImage: `url('${storeImg}')` }}
            ></div>
          </div>
        </div>

        {/* Tabs Of Store */}

        <div className={classes.storetabs}>
          <AppBar position="static" style={{ color: "#666" }}>
            <Tabs
              TabIndicatorProps={{ style: { background: "#fff" } }}
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              style={{ color: "#fff" }}
            >
              <Tab label="Homepage" {...a11yProps(0)} />
              <Tab label="All Products" {...a11yProps(1)} />
              <Tab label="Profile" {...a11yProps(2)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            {/* For HomePage */}
            <div className={classes.homePageTab}>
              <div
                className={classes.storeFrontProductsMainDiv}
                style={{
                  paddingBottom: data
                    ? data.topReviewedProducts
                      ? data.topReviewedProducts.length >= 5
                        ? 12
                        : 0
                      : 0
                    : 0,
                }}
              >
                {getTopSellingProducts() !== null
                  ? getTopSellingProducts().map((item) => {
                      return (
                        <Grid
                          lg={4}
                          md={8}
                          sm={10}
                          key={item}
                          className={classes.homePageTabMainProduct}
                          onClick={() => openProductPage(item._id)}
                          style={{ padding: 0 }}
                        >
                          <img
                            className={classes.homePageTabMainProductImg}
                            src={
                              Array.isArray(item.images)
                                ? item.images.length > 0
                                  ? item.images[0]
                                  : noImage
                                : item.images
                                ? item.images
                                : noImage
                            }
                          ></img>
                          <div
                            style={{
                              maxWidth: "100%",
                              padding: 10,
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography className={classes.badge}>
                              Top Selling
                            </Typography>
                            <Tooltip title={item.name}>
                              <Typography
                                variant="h6"
                                className={classes.mainProductText}
                                noWrap
                              >
                                {item.name}
                              </Typography>
                            </Tooltip>
                            <Typography className={classes.priceText}>
                              Rs.{" "}
                              {item.discountPrice
                                ? item.discountPrice
                                : item.salePrice}
                            </Typography>
                          </div>
                        </Grid>
                      );
                    })
                  : null}

                <Grid
                  lg={4}
                  md={6}
                  sm={10}
                  style={{
                    paddingLeft: 5,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {data ? (
                    data.TopReviewedProducts.length >= 3 ? (
                      <div
                        className={classes.subLandsProduct}
                        onClick={() =>
                          openProductPage(data.TopReviewedProducts[0]._id)
                        }
                      >
                        <img
                          className={classes.homePageTabSubProductImg}
                          src={
                            Array.isArray(data.TopReviewedProducts[0].images)
                              ? data.TopReviewedProducts[0].images.length > 0
                                ? data.TopReviewedProducts[0].images[0]
                                : noImage
                              : data.TopReviewedProducts[0].images
                              ? data.TopReviewedProducts[0].images
                              : noImage
                          }
                        ></img>
                        <div className={classes.subProductTextDiv}>
                          <Typography
                            variant="h6"
                            className={classes.subProductText}
                            noWrap
                          >
                            {data.TopReviewedProducts[0].name}
                          </Typography>
                          <Typography className={classes.priceText}>
                            Rs.{" "}
                            {data.TopReviewedProducts[0].discountPrice
                              ? data.TopReviewedProducts[0].discountPrice
                              : data.TopReviewedProducts[0].salePrice}
                          </Typography>
                          <Typography
                            className={classes.badge}
                            style={{ textAlign: "center" }}
                          >
                            Top Reviewed
                          </Typography>
                        </div>
                      </div>
                    ) : null
                  ) : null}
                  {/* SMall two products under landscape */}
                  <div
                    style={{
                      paddingTop: data
                        ? data.topReviewedProducts
                          ? data.topReviewedProducts.length >= 5
                            ? 15
                            : 0
                          : 0
                        : 0,
                    }}
                    className={classes.portraitProductsContainer}
                  >
                    {data
                      ? data.TopReviewedProducts.length >= 3
                        ? [
                            data.TopReviewedProducts[1],
                            data.TopReviewedProducts[2],
                          ].map((item) => {
                            return (
                              <div
                                key={item}
                                className={classes.portraitProduct}
                                onClick={() => openProductPage(item._id)}
                              >
                                <img
                                  className={classes.homePageTabSubProductImg}
                                  src={
                                    Array.isArray(item.images)
                                      ? item.images.length > 0
                                        ? item.images[0]
                                        : noImage
                                      : item.images
                                      ? item.images
                                      : noImage
                                  }
                                ></img>
                                <Typography
                                  className={classes.badge}
                                  style={{ textAlign: "center" }}
                                >
                                  Top Reviewed
                                </Typography>
                                <Tooltip title={item.name}>
                                  <Typography
                                    style={{
                                      padding: 3,
                                      fontWeight: "bold",
                                      maxWidth: 110,
                                    }}
                                    noWrap
                                  >
                                    {item.name}
                                  </Typography>
                                </Tooltip>
                                <Typography className={classes.priceText}>
                                  Rs.{" "}
                                  {item.discountPrice
                                    ? item.discountPrice
                                    : item.salePrice}
                                </Typography>
                              </div>
                            );
                          })
                        : null
                      : null}
                  </div>
                </Grid>
              </div>

              {/* Displaying All products of store */}
              <div className={classes.allProductsDiv}>
                <Typography className={classes.topProductsForText} variant="h4">
                  Top Products Just For You
                </Typography>
                {/* All Products Box */}
                <Grid container className={classes.productsMainGrid}>
                  {data
                    ? data.ForYouProducts
                      ? data.ForYouProducts.map((item) =>
                          React.cloneElement(
                            <ProductCard
                              _id={item._id}
                              image={
                                Array.isArray(item.images)
                                  ? item.images.length > 0
                                    ? item.images[0]
                                    : noImage
                                  : item.images
                                  ? item.images
                                  : noImage
                              }
                              title={item.name}
                              cutPrice={
                                item.discountPrice ? item.salePrice : null
                              }
                              price={
                                item.discountPrice
                                  ? item.discountPrice
                                  : item.salePrice
                              }
                              category={item.category}
                              isNew={item.state === "new" ? true : false}
                              rating={item.avgRating}
                              discountPercentage={
                                item.discountPercentage
                                  ? item.discountPercentage
                                  : ""
                              }
                              storeName={item.storeName}
                              totalRatingStars={item.totalRatingStars}
                              brand={item.vendorCompanyName}
                              shippingCost={item.shippingCost}
                              stockAvailable={item.stockAvailable}
                              _id={item._id}
                            />,
                            {
                              key: { item },
                            }
                          )
                        )
                      : null
                    : null}
                </Grid>
              </div>
              {/* <Button
                variant="outlined"
                style={{ display: "flex", left: 12, marginRight: "auto" }}
              >
                Load More {">>"}
              </Button> */}
            </div>
          </TabPanel>

          {/* ///////////Tab For Store Products */}
          <TabPanel value={value} index={1}>
            <StoreProducts
              storeId={selectedStoreId}
              storeName={storeDetails ? storeDetails.name : null}
            />
          </TabPanel>

          {/* //////////Tab for profile Info and reviews */}
          <TabPanel value={value} index={2}>
            <div>
              <Grid container lg={12} sm={12}>
                <div className={classes.infoDiv}>
                  <Grid lg={3} sm={12}>
                    <div
                      className={classes.profileInfoBox}
                      style={{ paddingBottom: 11 }}
                    >
                      <div>
                        <AccountBoxIcon className={classes.InfoIcon} />
                      </div>
                      <Typography noWrap variant="p" style={{ color: "#666" }}>
                        Store Name
                      </Typography>
                      <Typography noWrap variant="h5" style={{ maxWidth: 200 }}>
                        {storeDetails ? storeDetails.name : ""}
                      </Typography>
                      <div style={{ display: "flex" }}>
                        <VerifiedUserIcon
                          style={{ color: "#50B154", fontSize: 17 }}
                        />
                        <Typography style={{ color: "#50B154", fontSize: 13 }}>
                          Verified Seller
                        </Typography>
                      </div>
                    </div>
                  </Grid>

                  <Grid lg={3} sm={12}>
                    <div className={classes.profileInfoBox}>
                      <div>
                        <ListAltIcon className={classes.InfoIcon} />
                      </div>
                      <Typography noWrap variant="p" style={{ color: "#666" }}>
                        Store Category
                      </Typography>
                      <Typography noWrap variant="h5" style={{ maxWidth: 200 }}>
                        {storeDetails ? storeDetails.category : ""}
                      </Typography>
                    </div>
                  </Grid>

                  <Grid lg={3} sm={12}>
                    <div className={classes.profileInfoBox}>
                      <div>
                        <LocationOnIcon className={classes.InfoIcon} />
                      </div>
                      <Typography variant="p" style={{ color: "#666" }}>
                        Store Location
                      </Typography>
                      <Typography noWrap variant="h5" style={{ maxWidth: 200 }}>
                        {storeDetails
                          ? `${storeDetails.city}, ${storeDetails.country}`
                          : ""}
                      </Typography>
                    </div>
                  </Grid>

                  <Grid lg={3} sm={12}>
                    <div className={classes.profileInfoBox}>
                      <div>
                        <StarHalfIcon className={classes.InfoIcon} />
                      </div>
                      <Typography noWrap variant="p" style={{ color: "#666" }}>
                        Store Rating
                      </Typography>
                      <Typography variant="h5" style={{ maxWidth: 200 }}>
                        {avgRatingOfStore}
                      </Typography>
                    </div>
                  </Grid>
                </div>

                <div className={classes.bioBox} style={{ maxWidth: "100%" }}>
                  <Typography
                    noWrap
                    variant="h6"
                    style={{ fontWeight: "bold" }}
                  >
                    More About Afzaal Electronics
                  </Typography>
                  <Typography variant="p" style={{ marginTop: 10 }}>
                    {storeDetails ? storeDetails.biography : ""}
                  </Typography>
                </div>

                {/* Ratings and Reviews Box */}

                <Grid
                  style={{
                    border: "0.2px solid #e9e9e9",
                    marginTop: 30,
                    backgroundColor: "#fff",
                    width: "100%",
                    margin: 9,
                  }}
                >
                  <Box
                    borderLeft={3}
                    borderColor="primary.main"
                    style={{
                      borderBottom: "0.2px solid #e9e9e9",
                      padding: 20,
                      paddingLeft: 26,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: "bold",
                        textAlign: "justify",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Ratings and Reviews of{" "}
                      {storeDetails ? storeDetails.name : "Store"}
                    </Typography>
                  </Box>

                  <Box style={{ backgroundColor: "#fff", padding: 22 }}>
                    {/* Avg Ratings Box */}
                    <div className={classes.AvgRatingsBoxes}>
                      <div>
                        <Typography
                          variant="h6"
                          style={{
                            padding: 6,
                            paddingLeft: 0,
                            paddingBottom: 15,
                            color: "#666",
                          }}
                        >
                          Positive Seller Rating
                        </Typography>
                        <Typography
                          variant={positiveSellerRating ? "h1" : "h6"}
                          style={{ fontWeight: "bold" }}
                        >
                          {positiveSellerRating
                            ? `${positiveSellerRating}%`
                            : `No Ratings Given Yet.`}
                          {/* <span style={{ color: "grey", fontSize: 17 }}>
                            {" "}
                            / 5
                          </span> */}
                        </Typography>
                        <Rating
                          name="half-rating-read"
                          defaultValue={avgRatingOfStore ? avgRatingOfStore : 0}
                          //className={classes.ratingStars}
                          style={{ fontSize: 30, marginTop: 12 }}
                          precision={0.1}
                          readOnly
                        />
                        <Typography style={{ color: "grey", fontSize: 14 }}>
                          {data ? data.sumOfRatings : 0} Ratings
                        </Typography>
                      </div>

                      <div className={classes.numberedRatingsStarsBox}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center",
                            justifyContent: "center",
                            margin: "auto",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <Typography variant="p" style={{ padding: 8 }}>
                              5 Stars
                            </Typography>
                            <div style={{ padding: 5 }}>
                              <Rating
                                name="half-rating-read"
                                defaultValue={5}
                                style={{ fontSize: 20 }}
                                //className={classes.ratingStars}
                                precision={0.5}
                                readOnly
                              />
                              <LinearProgress
                                variant="determinate"
                                style={{
                                  backgroundColor: "#e9e9e9",
                                }}
                                value={fiveRatingCount * 10}
                              />
                            </div>
                          </div>

                          <div style={{ display: "flex" }}>
                            <Typography variant="p" style={{ padding: 8 }}>
                              4 Stars
                            </Typography>
                            <div style={{ padding: 5 }}>
                              <Rating
                                name="half-rating-read"
                                defaultValue={4}
                                style={{ fontSize: 20 }}
                                //className={classes.ratingStars}
                                precision={0.5}
                                readOnly
                              />
                              <LinearProgress
                                variant="determinate"
                                style={{
                                  backgroundColor: "#e9e9e9",
                                }}
                                value={fourRatingCount * 10}
                              />
                            </div>
                          </div>

                          <div style={{ display: "flex" }}>
                            <Typography variant="p" style={{ padding: 8 }}>
                              3 Stars
                            </Typography>
                            <div style={{ padding: 5 }}>
                              <Rating
                                name="half-rating-read"
                                defaultValue={3}
                                style={{ fontSize: 20 }}
                                //className={classes.ratingStars}
                                precision={0.5}
                                readOnly
                              />
                              <LinearProgress
                                variant="determinate"
                                style={{
                                  backgroundColor: "#e9e9e9",
                                }}
                                value={threeRatingCount * 10}
                              />
                            </div>
                          </div>

                          <div style={{ display: "flex" }}>
                            <Typography variant="p" style={{ padding: 8 }}>
                              2 Stars
                            </Typography>
                            <div style={{ padding: 5 }}>
                              <Rating
                                name="half-rating-read"
                                defaultValue={2}
                                style={{ fontSize: 20 }}
                                //className={classes.ratingStars}
                                precision={0.5}
                                readOnly
                              />
                              <LinearProgress
                                variant="determinate"
                                style={{
                                  backgroundColor: "#e9e9e9",
                                }}
                                value={twoRatingCount * 10}
                              />
                            </div>
                          </div>

                          <div style={{ display: "flex" }}>
                            <Typography
                              variant="p"
                              style={{ padding: 8, paddingRight: 19 }}
                            >
                              1 Stars
                            </Typography>
                            <div style={{ padding: 5 }}>
                              <Rating
                                name="half-rating-read"
                                defaultValue={1}
                                style={{ fontSize: 20 }}
                                //className={classes.ratingStars}
                                precision={0.5}
                                readOnly
                              />
                              <LinearProgress
                                variant="determinate"
                                style={{
                                  backgroundColor: "#e9e9e9",
                                }}
                                value={oneRatingCount * 100}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Customer Reviews Box */}
                    <div style={{ paddingTop: 30 }}>
                      <div
                        style={{
                          paddingBottom: 30,
                          borderBottom: "0.2px solid #e9e9e9",
                        }}
                      >
                        <Typography variant="h5" style={{ fontWeight: "bold" }}>
                          Customer Reviews
                        </Typography>
                      </div>

                      {/* Cutomer Review and rating row div */}
                      {storeReviews.length > 0 ? (
                        storeReviews.map((review) =>
                          React.cloneElement(
                            <div
                              style={{
                                display: "flex",
                                paddingTop: 20,
                                paddingBottom: 20,
                                // borderTop: "0.2px solid #e9e9e9",
                                borderBottom: "0.2px solid #e9e9e9",
                              }}
                            >
                              <div>
                                <div>
                                  <Rating
                                    name="half-rating-read"
                                    defaultValue={review.rating}
                                    style={{ fontSize: 20 }}
                                    //className={classes.ratingStars}
                                    precision={0.5}
                                    readOnly
                                  />
                                  <div
                                    className={
                                      classes.reviewVerificationAndTimeBox
                                    }
                                  >
                                    <Typography
                                      style={{
                                        color: "grey",
                                        fontSize: 13,
                                        maxWidth: 160,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      By {review.buyerName}
                                    </Typography>
                                    <div style={{ display: "flex" }}>
                                      <VerifiedUserIcon
                                        style={{
                                          color: "#50B154",
                                          fontSize: 17,
                                          marginLeft: 5,
                                        }}
                                      />
                                      <Typography
                                        style={{
                                          color: "#50B154",
                                          fontSize: 13,
                                        }}
                                      >
                                        Verified Purchase
                                      </Typography>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    paddingTop: 10,
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography variant="p">
                                    {review.comment}
                                  </Typography>
                                  <Typography
                                    variant="p"
                                    style={{
                                      fontStyle: "italic",
                                      marginTop: 5,
                                    }}
                                  >
                                    <Reply
                                      style={{ fontSize: 14 }}
                                      color="primary"
                                    />
                                    {review.response
                                      ? `${
                                          review.storeName
                                            ? review.storeName
                                            : null
                                        } Replied: ${review.response}`
                                      : null}
                                  </Typography>
                                  <div style={{ display: "flex" }}>
                                    {review.pictures.map((picture) => {
                                      return (
                                        <img
                                          src={picture ? picture : noImage}
                                          style={{
                                            maxWidth: 100,
                                            maxHeight: 100,
                                            paddingTop: 10,
                                          }}
                                        />
                                      );
                                    })}
                                  </div>
                                </div>
                                <div style={{ marginTop: 5, fontWeight:'bold', fontSize:13 }}>
                                {review.createdAt.split("T")[0]} ,{" "}
                                {review.createdAt.split("T")[1].split(":")[0]}:
                                {review.createdAt.split("T")[1].split(":")[1]}{" "}
                              </div>
                              </div>
                             
                            </div>,
                            {
                              key: review._id,
                            }
                          )
                        )
                      ) : (
                        <Typography style={{ marginTop: 10 }}>
                          No Reviews given yet.
                        </Typography>
                      )}
                    </div>
                  </Box>
                  <Button
                    variant="outlined"
                    style={{
                      display: "flex",
                      right: 20,
                      bottom: 10,
                      marginLeft: "auto",
                      visibility: storeReviews.length > 20 ? "block" : "hidden",
                    }}
                  >
                    Load More {">>"}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </TabPanel>
        </div>
      </div>
    </div>
  );
}
